export default "__VITE_ASSET__6c656dd8__"